import { execa } from 'execa';

/**
 * Service for executing kit hooks
 */
export class HookExecutor {
    constructor(
        private cwd: string,
        private variables: Record<string, string>
    ) {}

    /**
     * Run hooks sequentially
     */
    async run(hooks: string[]): Promise<void> {
        for (const hook of hooks) {
            const cmd = this.replaceVariables(hook);
            console.log(`   $ ${cmd}`);

            try {
                await execa(cmd, {
                    cwd: this.cwd,
                    shell: true,
                    stdio: 'inherit',
                });
            } catch (error) {
                throw new Error(`Hook failed: ${cmd}`);
            }
        }
    }

    /**
     * Replace variables in command
     */
    private replaceVariables(cmd: string): string {
        let result = cmd;
        for (const [key, value] of Object.entries(this.variables)) {
            result = result.replace(new RegExp(`\\{\\{${key}\\}\\}`, 'g'), value);
        }
        return result;
    }
}
